import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './offlineEvent.css';
import offlineEventData from './offlineEventData';

const OfflineEventTemplate = () => {

  const { slug } = useParams();
  const data = offlineEventData[slug];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  if (!data) return <h1>Event Not Found</h1>;

  return (
    <div className="event-page">

      {/* HERO */}
      <section className="event-hero">

        <div className="event-left">

          <div className="event-badge">{data.badge}</div>

          <h1>{data.title}</h1>

          <p className="event-desc">{data.description}</p>

          <div className="event-meta">
            <span>📍 {data.location}</span>
            <span>👥 {data.attendees}</span>
            <span>📅 {data.date}</span>
          </div>

        </div>

        <div className="event-right">
  <video
    src={data.heroVideo}
    autoPlay
    loop
    muted
    playsInline
  />
</div>

      </section>

      {/* STATS */}
      <section className="event-stats">

        {data.stats.map((item, i) => (
            <div key={i} className={`stat-card stat-${i}`}>
            <h3>{item.number}</h3>
            <p>{item.label}</p>
          </div>
        ))}

      </section>

      {/* CONTENT */}
      <section className="event-content">

        {/* LEFT */}
        <div className="event-info">

          <h3 className="section-title">EVENT AT A GLANCE</h3>

          <div className="info-item">
            <span>Event Type</span>
            <p>{data.eventDetails.type}</p>
          </div>

          <div className="info-item">
            <span>Target Audience</span>
            <p>{data.eventDetails.audience}</p>
          </div>

          <div className="info-item">
            <span>Execution</span>
            <p>{data.eventDetails.execution}</p>
          </div>

          <div className="info-item">
            <span>Organized By</span>
            <p>{data.eventDetails.organizer}</p>
          </div>

          <div className="info-item">
            <span>Client / Partner</span>
            <p>{data.eventDetails.client}</p>
          </div>

        </div>

        {/* RIGHT */}
        <div className="event-gallery">

          {/* TOP 3 */}
          <div className="gallery-top">
            {data.gallery.slice(0, 3).map((img, i) => (
              <img key={i} src={img} alt="event" />
            ))}
          </div>

          {/* BOTTOM 2 */}
          <div className="gallery-bottom">
            {data.gallery.slice(3, 5).map((img, i) => (
              <img key={i} src={img} alt="event" />
            ))}
          </div>

        </div>

      </section>

      {/* CTA */}
      <section className="event-cta">

        <div className="cta-left">
          <div className="cta-icon">📸</div>
          <div>
            <h3>Want to see more?</h3>
            <p>View more glimpses and impact from this event.</p>
          </div>
        </div>

        <button onClick={() => setIsModalOpen(true)}>
          View More Photos
        </button>

      </section>

      {/* MODAL */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>

          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="modal-header">
              <h3>Event Gallery</h3>
              <button onClick={() => setIsModalOpen(false)}>✕</button>
            </div>

            <div className="modal-gallery">
              {data.gallery.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt="event"
                  onClick={() => setSelectedImage(img)}
                />
              ))}
            </div>

          </div>

        </div>
      )}

      {/* ZOOM VIEW */}
      {selectedImage && (
        <div
          className="zoom-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="zoom"
            className="zoom-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

    </div>
  );
};

export default OfflineEventTemplate;